import GetEmployeeByUserIdRequestModelBase from '../_generated/modelBases/get-employee-by-user-id-request-model-base';

export default class GetEmployeeByUserIdRequestModel extends GetEmployeeByUserIdRequestModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
